import React from 'react';
// import PropTypes from 'prop-types';
import { Menu } from 'antd';

import {
  SettingOutlined,
  // UnorderedListOutlined,
  TeamOutlined,
  BarChartOutlined,
  FileAddOutlined,
} from '@ant-design/icons';

import rupeeIcon from './rupee-icon.svg';
import './style.css';

const SiderMenu = ({ activeKeys, ability, onMenuClick }) => {
  return (
    <>
      <Menu theme="dark" mode="inline" selectedKeys={activeKeys}>
        <Menu.Item
          key="path:/"
          icon={<TeamOutlined />}
          onClick={() => onMenuClick('/')}
        >
          Employees
        </Menu.Item>
        {ability.toAccessExpense && (
          <Menu.Item
            key="path:/expense"
            icon={<FileAddOutlined />}
            onClick={() => onMenuClick('/expense')}
          >
            Expense
          </Menu.Item>
        )}
        {ability.toAccessPayroll && (
          <Menu.Item
            key="path:/payroll"
            icon={
              <img
                src={rupeeIcon}
                className="sider-menu-rupee-icon"
                alt="Expense"
              />
            }
            onClick={() => onMenuClick('/payroll')}
          >
            Payroll
          </Menu.Item>
        )}
        {ability.toAccessReports && (
          <Menu.Item
            key="path:/reports"
            icon={<BarChartOutlined />}
            onClick={() => onMenuClick('/reports')}
          >
            Reports
          </Menu.Item>
        )}
        {ability.toAccessSettings && (
          <Menu.Item
            key="path:/settings"
            icon={<SettingOutlined />}
            onClick={() => onMenuClick('/settings')}
          >
            Settings
          </Menu.Item>
        )}
        {/* <SubMenu key="sub1" icon={<UserOutlined />} title="User">
            <Menu.Item key="3">Tom</Menu.Item>
            <Menu.Item key="4">Bill</Menu.Item>
            <Menu.Item key="5">Alex</Menu.Item>
          </SubMenu>           */}
      </Menu>
    </>
  );
};

SiderMenu.defaultProps = {};

SiderMenu.propTypes = {};

export default SiderMenu;
